export class ResearchInfrastructureModuleOptions {

    public static readonly DOCUMENTATION_ARTICLE = 'Forschungsinfrastrukturen-HISinOne.xhtml';
    public static readonly DOCUMENTATION_TITLE= 'fs.res.documentation.infrastructure';

    public static readonly RIGHT_CREATE = [
        'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_CREATE_RESEARCH_INFRASTRUCTURE'
    ];
    public static readonly RIGHT_DELETE = [
        'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_DELETE_RESEARCH_INFRASTRUCTURE'
    ];
    public static readonly RIGHT_EDIT= [
        'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_EDIT_RESEARCH_INFRASTRUCTURE'
    ];
    public static readonly RIGHT_VIEW = [
        'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_VIEW_RESEARCH_INFRASTRUCTURE',
        'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_VIEW_RESEARCH_INFRASTRUCTURE_VISIBLE'
    ];

    public static readonly SEARCH_CONFIGURATION_FILENAME = 'fs/res/searchResearchInfrastructure.xml';
}
